import HOME from '@/api/home'
// import structure from '@/assets/structure.json'
const state = {
  structure: null
}

// getters
const getters = {
  structure: (state) => {
    return state.structure
  }
}

// actions
const actions = {
  fetchCurrencyRate: function ({ state }) {
    return HOME.getCurrencyRate().then(res => {
      if (res.data) {
        return res.data
      }
      return res
    })
  },
  fetchStructure: function ({ commit, state, rootGetters }) {
    return HOME.getPageStructure({ currency: rootGetters['user/selectedCurrency'] }).then(res => {
      if (res.data) {
        commit('SET_STRUCTURE', res.data)
        return res.data
      } else {
        return res
      }
    })
  },
  fetchBannerList: function ({ state }) {
    return HOME.getBannerList().then(res => {
      if (res.data) {
        return res.data
      }
      return res
    })
  }
}

// mutations
const mutations = {
  SET_STRUCTURE: function (state, payload) {
    state.structure = payload
  }
}

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
}
